module.exports = __webpack_public_path__ + "img/app_01.aa44f478.jpg";